// apps/webapp/webapp/src/redesign/popover-two-column-table/popover-two-columns-styled-components.tsx

import { Box, Popover, popoverClasses } from '@mui/material';
import { styled } from '@mui/material/styles';

const iconHeight = 20;
const iconWidth = 20;

export const StyledPopover = styled(Popover)(({ theme }) => ({
  pointerEvents: 'none',
  [`& .${popoverClasses.paper}`]: {
    overflow: 'visible',
    pointerEvents: 'auto',
    borderRadius: theme.shape.borderRadius * 3,
    boxShadow: `0 10px 30px ${theme.palette.lwBlack[10]}, 0 6px 12px ${theme.palette.lwBlack[6]}`,
    marginTop: theme.spacing(3),
    '&::before': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      top: `-${theme.spacing(3)}`,
      height: theme.spacing(3),
    },
  },
}));

export const PaperContent = styled(Box)(() => ({
  overflow: 'hidden',
  borderRadius: 'inherit',
}));

export const PaperContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(5),
  width: '100%',
}));

export const HeaderContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingBottom: theme.spacing(3),
  justifyContent: 'space-between',
}));

export const ContentWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const LabelContainer = styled(Box)(({ theme }) => ({
  minWidth: 140,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  color: theme.palette.text.secondary,
}));

export const IconWrapper = styled(Box)(() => ({
  width: iconWidth,
  height: iconHeight,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const ColoredIcon = styled(Box)(() => ({
  width: iconWidth,
  height: iconHeight,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg, & svg *': {
    stroke: '#646464',
  },
  '& svg': {
    width: iconWidth,
    height: iconHeight,
  },
}));

export const FallbackCircle = styled(Box)(({ theme }) => ({
  width: iconWidth,
  height: iconHeight,
  borderRadius: '50%',
  backgroundColor: theme.palette.action.hover,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 14,
  fontWeight: 600,
  color: theme.palette.text.secondary,
}));
